import React from "react";
import { Link } from "react-router-dom";
import { Home, Flower, Shield, Heart, TrendingUp, ArrowRight } from "lucide-react";

const solutions = [
  {
    Icon: Home,
    title: "Mortgage Protection",
    copy: "Protect your family's home and financial future if the unexpected happens. Coverage designed to keep your loved ones in the home they love.",
    span: "md:col-span-7",
    testid: "sol-mortgage",
  },
  {
    Icon: Flower,
    title: "Final Expense",
    copy: "Help your loved ones avoid the burden of funeral and end-of-life expenses with affordable, guaranteed coverage.",
    span: "md:col-span-5",
    testid: "sol-final",
  },
  {
    Icon: Shield,
    title: "Life Insurance",
    copy: "Affordable, flexible protection designed to fit your family's needs and long-term goals — term, whole, and indexed options.",
    span: "md:col-span-5",
    testid: "sol-life",
  },
  {
    Icon: Heart,
    title: "Living Benefits",
    copy: "Access benefits while living for qualifying critical, chronic, or terminal illnesses — protection that protects you, too.",
    span: "md:col-span-7",
    testid: "sol-living",
  },
  {
    Icon: TrendingUp,
    title: "Retirement & Wealth Strategies",
    copy: "Tax-advantaged solutions designed to help you create long-term financial security, generational wealth, and a worry-free retirement.",
    span: "md:col-span-12",
    testid: "sol-retire",
  },
];

export default function Insurance() {
  return (
    <div data-testid="insurance-page" className="pt-32">
      <section className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pb-16">
        <div className="overline mb-6">— Insurance Solutions</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-[6.5rem] text-white tracking-tighter leading-[0.95] max-w-5xl">
          Coverage built around <span className="italic text-[#D4AF37]">real life.</span>
        </h1>
        <p className="mt-8 text-white/70 max-w-2xl text-lg leading-relaxed">
          From your first home to your retirement years, every Impact Legacy solution is designed around the people you love — and the legacy you're building.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pb-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {solutions.map(({ Icon, title, copy, span, testid }, i) => (
            <article
              key={title}
              data-testid={testid}
              className={`card-luxury group ${span} p-10 md:p-12 flex flex-col justify-between min-h-[280px] relative overflow-hidden`}
            >
              <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-[#008B8B]/0 group-hover:bg-[#008B8B]/10 blur-3xl transition-all duration-700" />
              <div className="relative">
                <div className="flex items-center justify-between mb-8">
                  <div className="w-14 h-14 border border-[#D4AF37]/50 flex items-center justify-center group-hover:bg-[#D4AF37] group-hover:text-black transition-all duration-500">
                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                  <span className="font-serif text-2xl text-white/20">0{i + 1}</span>
                </div>
                <h3 className="font-serif text-3xl md:text-4xl text-white mb-4 leading-tight">{title}</h3>
                <p className="text-white/65 leading-relaxed max-w-xl">{copy}</p>
              </div>
              <div className="relative mt-8">
                <Link to="/contact" className="inline-flex items-center gap-2 text-[#D4AF37] text-xs tracking-[0.22em] uppercase group-hover:gap-4 transition-all">
                  Discuss Options <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-20 border border-[#D4AF37]/30 p-10 md:p-16 text-center bg-gradient-to-br from-[#008B8B]/5 to-transparent">
          <div className="overline mb-5">— Personalized Consultation</div>
          <h3 className="font-serif text-3xl md:text-5xl text-white mb-6 max-w-3xl mx-auto leading-tight">
            Not sure which coverage fits your family? <span className="italic text-[#D4AF37]">Let's talk.</span>
          </h3>
          <Link to="/contact" data-testid="insurance-cta" className="btn-primary">
            Schedule a Conversation <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
